<template>
    <el-row type="flex" justify="space-between" class="store"
            @click.native="goContent(orderSn)">
        <el-col :span="4">
            <el-image class="avatar" :src="brandImage" fit="cover"/>
        </el-col>
        <el-col :span="20">
            <el-row type="flex" justify="space-between" class="name">
                <el-col :span="23" class="text">{{ brandName }}<span class="ml-3" v-if="storeName !== ''">{{ storeName }}</span>
                </el-col>
                <el-col :span="1">
                    <img src="@/assets/images/pink-arrow.svg" alt="">
                </el-col>
            </el-row>
            <el-row type="flex" justify="space-between" class="detail">
                <el-col :span="16">
                    <ul class="left">
                        <li class="block">{{ createdAt }}</li>
                        <li v-if="isOnlineOrder">線上點餐</li>
                        <li v-else-if="isPosReserve">線上預訂</li>
                        <!--<li class="red" v-else>現場結帳</li>-->
                    </ul>
                </el-col>
                <el-col :span="8" class="text-right">
                    <ul class="right">
                        <li v-if="isInvalid"><span class="void">已作廢</span></li>
                        <li>{{ invoicePrice }} 元</li>
                    </ul>
                </el-col>
            </el-row>
        </el-col>

        <CommDialog :value="isShowDialog"
                    class="isWeb"
                    :appendToBody="true"
                    :isIcon="false"
                    :isCancel="false"
                    :outerContent="''"
                    :isShowClose="true"
                    @result="onCommDialogClose">
            <HistoryContent isWeb :orderSnWeb="orderSn" class="web-content"/>
        </CommDialog>
    </el-row>
</template>

<script>
    import CommDialog from "@/components/CommDialog";
    import HistoryContent from "@/views/more/history/HistoryContent";

    export default {
        name: "Store",
        props: ['brandName', 'isInvalid', 'storeName', 'invoicePrice', 'createdAt', 'brandImage', 'orderSn', 'isOnlineOrder',
            'isPosReserve', 'isWeb' , 'orderSnWeb'],
        components: {
            CommDialog,
            HistoryContent,
        },
        data() {
            return {
                isShowDialog: false,
            }
        },
        created() {

        },
        mounted() {

        },
        methods: {
            goContent(orderSn){
                if (!this.isWeb){
                    this.$router.push({ name: 'HistoryContent', params:{'orderSn': orderSn} })
                }else {
                    //單店網頁版用
                    this.isShowDialog = true;
                }
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                this.isShowDialog = false;
            },
        }
    }
</script>

<style lang="less" scoped>
    .store {
        padding: 10px;
        border-bottom: 1px solid #e0e0e0;
        cursor: pointer;
        .el-col-4 {
            @media (min-width: 1024px) {
                width: 70px;
            }
        }
        .el-col-20 {
            @media (min-width: 1024px) {
                flex: 1;
            }
        }
        a {
            width: 100%;
            @media (min-width: 1024px) {
                display: flex;
            }
        }
        .avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
        }
        .name {
            color: #6F5B62;
            font-size: 16px;
            padding-left: 5px;
            .text {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
            }
            img {
                width: 8px;
                margin-left: 4px
            }
        }
        .detail {
            margin-top: 4px;
            .left {
                font-size: 14px;
                line-height: 22px;
                li {
                    margin-left: 5px;
                    color: var(--color-dark2);
                }
                .block {
                    font-size: 12px;
                }
            }
            .right {
                font-size: 14px;
                color: #CD646C;
                line-height: 22px;
                .void {
                    color: #fff;
                    padding: 2px 10px;
                    background: #A9A29B;
                    border-radius: 20px;
                    font-size: 12px;
                }
            }
        }
        .link {
            padding: 8px 20px;
            color: #8E8E8F
        }
    }
</style>